/**
 * Who is behind it, on the home page.
 *
 * A self-hosted control plane that runs an organisation's provider accounts on
 * its own machines is bought from somebody, not downloaded from nobody. For a
 * Turkish enterprise reader the question "who are these people" arrives before
 * the second feature, and a page that answers it only in a footer is a page that
 * has decided the answer is embarrassing.
 *
 * The address is the credential. ODTÜ Teknokent is a fact a reader in this
 * market places instantly, and it costs one line.
 *
 * Read from `data/links.ts` rather than from the catalogue: a street address is
 * not a translation, and holding one per language is two places for a telephone
 * number to be wrong. Only the labels around it are translated.
 */
import { Reveal } from '../kit'
import { useLocale, useT } from '../i18n/context'
import { COMPANY } from '../data/links'
import { pathFor } from '../routes'
import { Logo } from '../components/Logo'

export function CompanyStrip() {
  const t = useT()
  const locale = useLocale()

  return (
    <section className="kl-section kl-companystrip" aria-labelledby="companystrip-title">
      <div className="kl-inner">
        <Reveal className="kl-companystrip__card">
          <div className="kl-companystrip__mark" aria-hidden="true">
            <Logo size={34} />
          </div>
          <div className="kl-companystrip__body">
            <p className="k-eyebrow">
              <span className="k-label">{t('home.company.eyebrow')}</span>
            </p>
            <h2 id="companystrip-title" className="kl-companystrip__title">
              {COMPANY.legalName}
            </h2>
            <p className="kl-companystrip__sub">{t('home.company.sub')}</p>
            <address className="kl-companystrip__address">
              <span>{COMPANY.address}</span>
              <span>
                {COMPANY.district} · {COMPANY.country}
              </span>
            </address>
          </div>
          <p className="kl-companystrip__more">
            <a className="kl-textlink" href={pathFor(locale, 'company')}>
              {t('home.company.link')}
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  )
}
